import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
     router:"",
     programme:"智慧园区",
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
